import { BaseResults } from 'libs/athos/components/recommendations/BaseResults'

export function GridResults({
  className,
  wrapperClassName = '',
  productCardSettings
}) {
  return (
    <BaseResults
      className={className}
      wrapperClassName={`${wrapperClassName} gap-grid-mb md:gap-grid flex-wrap`}
      productCardSettings={productCardSettings}
    />
  )
}
